module.exports = __webpack_public_path__ + "static/media/vegitables_30.878819cb.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_30.csv
// module id = 614
// module chunks = 0